/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import OptionItem from '@fai/friendli-suite/views/layout/product/option-item';
import { teamOwnerSettingsMenus } from '@fai/friendli-suite/views/layout/product/team-owner-settings-menus';

export function MenuOptions({ teamId }: { teamId: string }) {
  const teamMenuList = teamOwnerSettingsMenus(teamId);
  const filteredTeamMenuList = teamMenuList.filter(({ isVisible }) => isVisible === true);

  if (filteredTeamMenuList.length <= 0) return null;

  return filteredTeamMenuList.map(({ isVisible, value, label, leftSection }) => (
    <OptionItem
      key={value}
      isVisible={isVisible}
      label={label}
      leftSlot={leftSection}
      value={value}
    />
  ));
}
